import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { NodeEntry, Node } from '@alfresco/js-api';
import { WkAlfrescoApiService } from './wk-alfresco-api.service';

@Injectable({
  providedIn: 'root',
})
export class ExternalMetadataApiService {
  externalMetadataPrefix = 'externals_';

  constructor(private readonly apiService: WkAlfrescoApiService) {}

  getExternalsClass(className: string): Observable<Node> {
    const contentTypes = ['application/json'];
    const pathParams = {
      className,
    };

    return from(
      this.apiService.callContentClientCustomApi({
        path: '/externals/{className}',
        httpMethod: 'GET',
        pathParams,
        contentTypes,
        accepts: contentTypes,
        returnType: NodeEntry,
      })
    ).pipe(map((res: any) => res.entry));
  }
}
